/**
 * Mayceline cart qty — collapse duplicate lines (BUY 2 GET 1 / race-safe).
 * Always update by variant: one line per variant_id after +/-.
 */
(function () {
  'use strict';

  if (window.__maycelineCartFastBoundV3) return;
  window.__maycelineCartFastBoundV3 = true;
  window.__maycelineCartFastBound = true;

  var busy = false;

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
  }

  function postUpdate(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ updates: updates }),
    }).then(function (r) {
      return r.json();
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  /** Public props only — ignore Shopify/_ app keys so identical variants merge. */
  function propsSig(item) {
    var props = item.properties || {};
    var keys = Object.keys(props).filter(function (k) {
      return k && k.charAt(0) !== '_' && String(props[k] || '').length > 0;
    });
    keys.sort();
    return keys
      .map(function (k) {
        return k + '=' + props[k];
      })
      .join('&');
  }

  function groupKey(item) {
    var plan =
      (item.selling_plan_allocation &&
        item.selling_plan_allocation.selling_plan &&
        item.selling_plan_allocation.selling_plan.id) ||
      '';
    return String(item.variant_id) + '::' + propsSig(item) + '::' + String(plan);
  }

  /** Collapse UI-identical duplicate lines into one. */
  function mergeDuplicateLines(cart) {
    if (!cart || !cart.items || cart.items.length < 2) {
      return Promise.resolve(cart);
    }
    var groups = {};
    cart.items.forEach(function (item) {
      var sig = groupKey(item);
      if (!groups[sig]) groups[sig] = [];
      groups[sig].push(item);
    });
    var updates = {};
    var need = false;
    Object.keys(groups).forEach(function (sig) {
      var list = groups[sig];
      if (list.length < 2) return;
      need = true;
      var total = 0;
      list.forEach(function (it) {
        total += it.quantity;
      });
      updates[list[0].key] = total;
      for (var i = 1; i < list.length; i++) {
        updates[list[i].key] = 0;
      }
    });
    if (!need) return Promise.resolve(cart);
    return postUpdate(updates);
  }

  /**
   * Set absolute qty for a line key, collapsing any sibling duplicates of same variant.
   */
  function setQtyForLine(lineKey, quantity, variantId) {
    if (!lineKey || busy) return Promise.resolve();
    busy = true;
    var qty = parseInt(quantity, 10);
    if (isNaN(qty) || qty < 0) qty = 0;

    return fetchCart()
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var primary = null;
        for (var i = 0; i < items.length; i++) {
          if (items[i].key === lineKey) {
            primary = items[i];
            break;
          }
        }
        var vid = variantId || (primary && primary.variant_id);
        if (!primary && !vid) {
          return postUpdate(
            (function () {
              var u = {};
              u[lineKey] = qty;
              return u;
            })()
          );
        }

        var sig = primary ? groupKey(primary) : null;
        var siblings = items.filter(function (it) {
          if (sig) return groupKey(it) === sig;
          return String(it.variant_id) === String(vid);
        });
        if (!siblings.length && primary) siblings = [primary];

        var updates = {};
        if (qty <= 0) {
          siblings.forEach(function (it) {
            updates[it.key] = 0;
          });
        } else {
          var keep = primary || siblings[0];
          siblings.forEach(function (it) {
            updates[it.key] = 0;
          });
          updates[keep.key] = qty;
        }
        return postUpdate(updates);
      })
      .then(function () {
        return fetchCart().then(mergeDuplicateLines);
      })
      .then(function () {
        refreshCart();
      })
      .catch(function (err) {
        console.warn('[mayceline-cart-qty]', err);
        refreshCart();
      })
      .then(function () {
        busy = false;
        // Late heal — catches theme races that add a second line after us
        window.setTimeout(function () {
          fetchCart()
            .then(function (cart) {
              if (!cart || !cart.items || cart.items.length < 2) return null;
              var before = cart.items.length;
              return mergeDuplicateLines(cart).then(function (result) {
                var after =
                  result && result.items ? result.items.length : before;
                if (after < before) refreshCart();
              });
            })
            .catch(function () {});
        }, 280);
      });
  }

  function lineKeyFromEl(el) {
    if (!el || !el.closest) return null;
    var item = el.closest('[data-item]');
    if (!item) return null;
    return (
      item.getAttribute('data-item') ||
      (item.querySelector('input[name="updates[]"]') &&
        item.querySelector('input[name="updates[]"]').getAttribute('data-id')) ||
      null
    );
  }

  function variantIdFromEl(el) {
    var item = el && el.closest && el.closest('[data-item]');
    return item ? item.getAttribute('data-variant-id') : null;
  }

  function qtyInputFor(el) {
    var item = el && el.closest && el.closest('[data-item]');
    if (!item) return null;
    return item.querySelector('input[name="updates[]"]');
  }

  function handleQtyClick(e) {
    var removeBtn = e.target && e.target.closest && e.target.closest('[data-item-remove]');
    if (removeBtn) {
      var rid = removeBtn.getAttribute('data-id') || lineKeyFromEl(removeBtn);
      if (!rid) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      setQtyForLine(rid, 0, variantIdFromEl(removeBtn));
      return;
    }

    var btn =
      e.target &&
      e.target.closest &&
      e.target.closest(
        'button[name="increase"], button[name="decrease"], .cart__quantity-plus, .cart__quantity-minus'
      );
    if (!btn) return;

    var item = btn.closest('[data-item]');
    if (!item) return;

    var input = qtyInputFor(btn);
    var id =
      btn.getAttribute('data-line-key') ||
      (input && (input.getAttribute('data-id') || input.dataset.id)) ||
      item.getAttribute('data-item');
    if (!id) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var current = input ? parseInt(input.value, 10) : 1;
    if (isNaN(current)) current = 1;

    var isPlus =
      btn.name === 'increase' || btn.classList.contains('cart__quantity-plus');
    var isMinus =
      btn.name === 'decrease' || btn.classList.contains('cart__quantity-minus');

    var next = current;
    if (isPlus) next = current + 1;
    else if (isMinus) next = Math.max(0, current - 1);
    else return;

    if (input) input.value = String(next);
    setQtyForLine(id, next, item.getAttribute('data-variant-id'));
  }

  document.addEventListener('click', handleQtyClick, true);

  document.addEventListener(
    'theme:cart:update',
    function (e) {
      var detail = e.detail || {};
      var id = detail.id;
      if (!id) {
        var t = e.target;
        var input = t && t.querySelector ? t.querySelector('input[name="updates[]"]') : null;
        if (input) id = input.getAttribute('data-id') || input.dataset.id;
      }
      if (!id) return;
      e.stopImmediatePropagation();
      if (typeof e.preventDefault === 'function') e.preventDefault();
      var item =
        (e.target && e.target.closest && e.target.closest('[data-item]')) ||
        document.querySelector('[data-item="' + CSS.escape(String(id)) + '"]');
      var vid = item ? item.getAttribute('data-variant-id') : null;
      setQtyForLine(id, detail.quantity, vid);
    },
    true
  );

  function patchCartItems() {
    var Ctor = customElements.get('cart-items');
    if (!Ctor || !Ctor.prototype || Ctor.prototype.__mayQtyPatchedV2) return;
    Ctor.prototype.__mayQtyPatchedV2 = true;
    var orig = Ctor.prototype.updateCart;
    if (typeof orig !== 'function') return;
    Ctor.prototype.updateCart = function (t, e) {
      t = t || {};
      if (t.id != null && t.quantity != null) {
        var el = this.querySelector && this.querySelector('[data-item="' + t.id + '"]');
        var vid = el ? el.getAttribute('data-variant-id') : null;
        return setQtyForLine(t.id, t.quantity, vid);
      }
      return orig.call(this, t, e);
    };
  }

  if (customElements.get('cart-items')) patchCartItems();
  else customElements.whenDefined('cart-items').then(patchCartItems);

  /**
   * Heal duplicates WITHOUT always calling refreshCart.
   * Old path: open → heal → refresh → theme:cart:change → heal → … forever,
   * and theme build’s theme:product:added re-opened the drawer after close.
   */
  var healInFlight = false;
  var lastHealAt = 0;

  function mergeThenMaybeRefresh() {
    return fetchCart()
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length < 2) {
          return { merged: false };
        }
        var before = cart.items.length;
        return mergeDuplicateLines(cart).then(function (result) {
          var after =
            result && result.items ? result.items.length : before;
          // postUpdate returns a cart; only refresh when line count dropped
          // or we actually had a multi-line group to collapse.
          var merged = after < before;
          if (!merged && result && result.items) {
            // Detect key-based collapse that kept same length (rare)
            merged = false;
          }
          return { merged: merged, cart: result };
        });
      })
      .then(function (info) {
        if (info && info.merged) refreshCart();
        return info;
      });
  }

  function healFromCartJs() {
    var now = Date.now();
    if (healInFlight) return;
    if (now - lastHealAt < 400) return; // debounce feedback loop
    healInFlight = true;
    lastHealAt = now;
    mergeThenMaybeRefresh()
      .catch(function () {})
      .then(function () {
        healInFlight = false;
      });
  }

  document.addEventListener('theme:cart-drawer:open', healFromCartJs);
  document.addEventListener('theme:cart:change', function () {
    window.setTimeout(healFromCartJs, 180);
  });
  document.addEventListener('theme:cart:refresh', function () {
    // Merge-only — never refreshCart here (that re-fires theme:cart:refresh).
    window.setTimeout(function () {
      if (healInFlight) return;
      fetchCart()
        .then(function (cart) {
          return mergeDuplicateLines(cart);
        })
        .catch(function () {});
    }, 200);
  });
})();
